module.exports = __webpack_public_path__ + "media/tolling-bell_daniel-simion.93fe1910.mp3";